import { CircularProgress } from '@mui/material';
import React from 'react';
import CloudDownloadOutlinedIcon from '@mui/icons-material/CloudDownloadOutlined';

interface IBulkExportModal {
  handleClose: () => void;
  fileName: string;
  setFileName: (name: string) => void;
  downloadFormat: string;
  setDownloadFormat: (format: string) => void;
  handleDownload: () => void;
  isDownloading: boolean;
  databaseType: string; // <-- 1. Add this new prop
}

const BulkExportModal: React.FC<IBulkExportModal> = ({
  handleClose,
  fileName,
  setFileName,
  downloadFormat,
  setDownloadFormat,
  handleDownload,
  isDownloading,
  databaseType, // <-- 2. Destructure it here
}) => {
  return (
    <div className='audit-add-modal-cont'>
      <div className='audit-add-modal-cont-head'>
        <div className='audit-add-modal-head-cont-change'>
          <div className='audit-add-modal-head-cont-icon'>
            <CloudDownloadOutlinedIcon
              sx={{ color: '#4895EF', width: '25px', height: '24px' }}
            />
          </div>
          <div className='audit-add-modal-head-cont-supporting'>
            <h1>Export Data</h1>
            <p>Enter a name and select your export format.</p>
          </div>
        </div>
        <div
          className='audit-add-modal-head-close'
          onClick={handleClose}
          style={{ cursor: 'pointer' }}
        >
          <svg
            xmlns='http://www.w3.org/2000/svg'
            width='24'
            height='24'
            viewBox='0 0 24 24'
            fill='none'
          >
            <path
              d='M18 6L6 18M6 6L18 18'
              stroke='#85888E'
              strokeWidth='2'
              strokeLinecap='round'
              strokeLinejoin='round'
            />
          </svg>
        </div>
      </div>
      <div className='activity-cont-frame-left-table-feed-row-cont-divider'></div>

      <div
        className='audit-add-modal-cont-body'
        style={{ paddingTop: '12px', paddingBottom: '12px' }}
      >
        {/* Filename Input */}
        <div className='audit-add-modal-cont-body-frame'>
          <div className='audit-add-modal-cont-body-frame-form'>
            <div className='audit-add-modal-cont-body-frame-form-row'>
              <div className='audit-add-modal-cont-body-frame-form-row-input'>
                <div className='audit-add-modal-cont-body-frame-form-row-input-label'>
                  <input
                    className='audit-add-modal-cont-body-frame-form-input'
                    type='text'
                    placeholder='e.g. Q4 Tariff Check'
                    value={fileName}
                    onChange={(e) => setFileName(e.target.value)}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Download Options */}
        <div className='audit-add-modal-cont-body-frame'>
          <div className='audit-add-modal-cont-body-frame-form'>
            <div className='audit-add-modal-cont-body-frame-form-row'>
              <div className='audit-add-modal-cont-body-frame-form-row-input'>
                <div className='audit-add-modal-cont-body-frame-form-row-input-label'>
                  <div className='audit-add-modal-cont-body-frame-form-row-input-label-text'>
                    Download Options
                  </div>
                  <div className='bill-container-fit-screen-content-row-selection'>
                    {/* BITE Default CSV - Always Visible */}
                    <div
                      className='bill-container-fit-screen-content-row-checkbox'
                      onClick={() => setDownloadFormat('BITE_DEFAULT')}
                    >
                      <div className='bill-container-fit-screen-content-row-input'>
                        <div
                          className={`bill-container-fit-screen-content-row-input-icon ${
                            downloadFormat === 'BITE_DEFAULT' ? 'selected' : ''
                          }`}
                        >
                          <div
                            className={`bill-container-fit-screen-content-row-input-icon-rnd ${
                              downloadFormat === 'BITE_DEFAULT'
                                ? 'selected'
                                : ''
                            }`}
                          />
                        </div>
                      </div>
                      <div className='bill-container-fit-screen-content-row-checkbox-text'>
                        <p>BITE Default CSV</p>
                      </div>
                    </div>

                    {/* Tariff Horizontal CSV - Conditionally Rendered */}
                    {databaseType === 'tariffs' && (
                      <div
                        className='bill-container-fit-screen-content-row-checkbox'
                        onClick={() => setDownloadFormat('TARIFF_HORIZONTAL')}
                      >
                        <div className='bill-container-fit-screen-content-row-input'>
                          <div
                            className={`bill-container-fit-screen-content-row-input-icon ${
                              downloadFormat === 'TARIFF_HORIZONTAL' ? 'selected' : ''
                            }`}
                          >
                            <div
                              className={`bill-container-fit-screen-content-row-input-icon-rnd ${
                                downloadFormat === 'TARIFF_HORIZONTAL' ? 'selected' : ''
                              }`}
                            />
                          </div>
                        </div>
                        <div className='bill-container-fit-screen-content-row-checkbox-text'>
                          <p>Tariff Summary CSV</p>
                        </div>
                      </div>
                    )}

                    {/* Custom Cargowise CSV - Conditionally Rendered */}
                    {databaseType === 'tariffs' && (
                      <div
                        className='bill-container-fit-screen-content-row-checkbox'
                        onClick={() => setDownloadFormat('CARGOWISE')}
                      >
                        <div className='bill-container-fit-screen-content-row-input'>
                          <div
                            className={`bill-container-fit-screen-content-row-input-icon ${
                              downloadFormat === 'CARGOWISE' ? 'selected' : ''
                            }`}
                          >
                            <div
                              className={`bill-container-fit-screen-content-row-input-icon-rnd ${
                                downloadFormat === 'CARGOWISE' ? 'selected' : ''
                              }`}
                            />
                          </div>
                        </div>
                        <div className='bill-container-fit-screen-content-row-checkbox-text'>
                          <p>Custom Cargowise CSV</p>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className='activity-cont-frame-left-table-feed-row-cont-divider'></div>

      {/* Footer / Submission */}
      <div className='audit-modal-cont-footer'>
        <div className='audit-modal-cont-footer-content'>
          <div
            className='audit-modal-cont-footer-content-btn-cancel'
            onClick={handleClose}
            style={{ cursor: 'pointer' }}
          >
            <div className='audit-modal-cont-footer-content-btn-text'>
              Cancel
            </div>
          </div>
          <div
            className='audit-modal-cont-footer-content-btn-upload'
            onClick={handleDownload}
            style={{ cursor: 'pointer' }}
          >
            <div
              className='audit-modal-cont-footer-content-btn-text'
              style={{ color: '#fff', display: 'flex', alignItems: 'center' }}
            >
              {isDownloading && (
                <CircularProgress
                  style={{
                    width: '20px',
                    height: '20px',
                    marginRight: '10px',
                    color: '#fff',
                  }}
                />
              )}
              Download
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BulkExportModal;
